/**
 * Create by Bowen: 2019/9/6
 * Description:
 * Relationship tree remove dialog component
 * Request:
 * 1. if we need to remove the item relationship, we need to check if the item is an entity or contact
 * (1) if the item is a entity, and topNode is a entity, the checkbox will show
 * (2) if the item is a entity, and topNode is a contact, the checkbox will not show
 * (3) if the item is a contact, and topNode is a contact, the checkbox will not show
 * (4) if the item is a contact, and topNode is a entity, the checkbox will not show
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { RelationshipTreeEvents } from '../relationship-tree.view-model';
import { RemoveRelationshipDialogService } from './remove-relationship-dialog.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tam-remove-relationship-dialog',
    templateUrl: './remove-relationship-dialog.component.html',
    styleUrls: ['./remove-relationship-dialog.component.scss']
})
export class RemoveRelationshipDialogComponent implements OnInit, OnDestroy {

    // var for common
    open = false;
    topNodeName = null;
    deleteOneRelationship = false;  // such as: ADVS, IBM
    deleteMultiRelationship = false; // such as: Attorney, related to
    isDeleteReciprocalRel = true;
    isContactParent = false;
    isEntityRootNode = true;
    eventKey: string;
    eventValue: string;

    // var for relationship
    currentClickedRelNodeName = null;
    currentClickedItemRelTypeName = null;

    // var for relationship type
    currentClickedRelTypeNodeName = null;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _removeRelationshipDialogService: RemoveRelationshipDialogService,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._removeRelationshipDialogService.openDialog$.subscribe(data => {
                // common vars
                this.topNodeName = data.payload.rootNodeName;
                this.isContactParent = data.payload.isContactParent;
                this.isEntityRootNode = data.payload.isEntityRootNode;

                if (data.type === 'removeOneRelationship') {
                    this.currentClickedRelNodeName = data.payload.showName;
                    this.currentClickedItemRelTypeName = data.payload.relationshipTypeName;
                    this.deleteOneRelationship = true;
                    this.deleteMultiRelationship = false;
                    this.eventKey = data.payload.eventKey;
                    this.eventValue = data.payload.eventValue;
                }
                if (data.type === 'removeMultiRelationship') {
                    this.currentClickedRelTypeNodeName = data.payload.relationshipTypeName;
                    this.deleteOneRelationship = false;
                    this.deleteMultiRelationship = true;
                    this.eventKey = data.payload.eventKey;
                    this.eventValue = data.payload.eventValue;
                }
                this.open = true;
            }));
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    close(event) {
        this._clearData();
        if (event) {
            event.stopImmediatePropagation();
        }
    }

    delete(event) {
        // delete item relationship, such as: ADVS, IBM
        if (this.deleteOneRelationship) {
            // it means that: if the checkbox shows, isDeleteReciprocalRel will get the value(user input)
            // if the checkbox hides, isDeleteReciprocalRel will be true for default
            if (this.isContactParent === true) {
                this.isDeleteReciprocalRel = true;
            }
            this._removeRelationshipDialogService.removeRelationship$.next({
                type: RelationshipTreeEvents.REMOVE_ONE_RELATIONSHIP,
                payload:
                {
                    isDeleteReciprocalRel: this.isDeleteReciprocalRel, // for entire item node
                }
            });
        }

        // delete parent relationship, such as: Attorney, related to
        if (this.deleteMultiRelationship) {
            this._removeRelationshipDialogService.removeRelationship$.next({
                type: RelationshipTreeEvents.REMOVE_MULTI_RELATIONSHIP,
                payload:
                {
                    isDeleteReciprocalRel: true && this.isDeleteReciprocalRel,
                }
            });
        }
        this._clearData();
        this._decorateEvent(event);
    }

    onClickSetEventValue(event) {
        this._decorateEvent(event);
    }

    private _clearData() {
        this.deleteOneRelationship = false;
        this.deleteMultiRelationship = false;
        this.isDeleteReciprocalRel = true;
        this.isContactParent = false;
        this.isEntityRootNode = false;
        this.open = false;
    }

    private _decorateEvent(event) {
        event[this.eventKey] = this.eventValue;
    }
}
